export const GET_RELOCATION_CONSULTANTS_REQUEST = 'GET_RELOCATION_CONSULTANTS_REQUEST';
export const GET_RELOCATION_CONSULTANTS_SUCCESS = 'GET_RELOCATION_CONSULTANTS_SUCCESS';
export const GET_RELOCATION_CONSULTANTS_FAILURE = 'GET_RELOCATION_CONSULTANTS_FAILURE';

export const GET_SEARCH_RESULTS_REQUEST = 'GET_SEARCH_RESULTS_REQUEST';
export const GET_SEARCH_RESULTS_SUCCESS = 'GET_SEARCH_RESULTS_SUCCESS';
export const GET_SEARCH_RESULTS_FAILURE = 'GET_SEARCH_RESULTS_FAILURE';

export const GET_COMMON_ADDRESS_REQUEST = 'GET_COMMON_ADDRESS_REQUEST';
export const GET_COMMON_ADDRESS_SUCCESS = 'GET_COMMON_ADDRESS_SUCCESS';
export const GET_COMMON_ADDRESS_FAILURE = 'GET_COMMON_ADDRESS_FAILURE';

export const POST_COMMON_ADDRESS_REQUEST = 'POST_COMMON_ADDRESS_REQUEST';
export const POST_COMMON_ADDRESS_SUCCESS = 'POST_COMMON_ADDRESS_SUCCESS';
export const POST_COMMON_ADDRESS_FAILURE = 'POST_COMMON_ADDRESS_FAILURE';

export const UPDATE_COMMON_ADDRESS_REQUEST = 'UPDATE_COMMON_ADDRESS_REQUEST';
export const UPDATE_COMMON_ADDRESS_SUCCESS = 'UPDATE_COMMON_ADDRESS_SUCCESS';
export const UPDATE_COMMON_ADDRESS_FAILURE = 'UPDATE_COMMON_ADDRESS_FAILURE';

export const DELETE_COMMON_ADDRESS_REQUEST = 'DELETE_COMMON_ADDRESS_REQUEST';
export const DELETE_COMMON_ADDRESS_SUCCESS = 'DELETE_COMMON_ADDRESS_SUCCESS';
export const DELETE_COMMON_ADDRESS_FAILURE = 'DELETE_COMMON_ADDRESS_FAILURE';

export const GET_INTERNAL_USERS_REQUEST = 'GET_INTERNAL_USERS_REQUEST';
export const GET_INTERNAL_USERS_SUCCESS = 'GET_INTERNAL_USERS_SUCCESS';
export const GET_INTERNAL_USERS_FAILURE = 'GET_INTERNAL_USERS_FAILURE';

export const POST_INTERNAL_USER_REQUEST = 'POST_INTERNAL_USER_REQUEST';
export const POST_INTERNAL_USER_SUCCESS = 'POST_INTERNAL_USER_SUCCESS';
export const POST_INTERNAL_USER_FAILURE = 'POST_INTERNAL_USER_FAILURE';

export const PUT_INTERNAL_USER_REQUEST = 'PUT_INTERNAL_USER_REQUEST';
export const PUT_INTERNAL_USER_SUCCESS = 'PUT_INTERNAL_USER_SUCCESS';
export const PUT_INTERNAL_USER_FAILURE = 'PUT_INTERNAL_USER_FAILURE';

export const DELETE_INTERNAL_USER_REQUEST = 'DELETE_INTERNAL_USER_REQUEST';
export const DELETE_INTERNAL_USER_SUCCESS = 'DELETE_INTERNAL_USER_SUCCESS';
export const DELETE_INTERNAL_USER_FAILURE = 'DELETE_INTERNAL_USER_FAILURE';

export const DELETE_VENDOR_REQUEST = 'DELETE_VENDOR_REQUEST';
export const DELETE_VENDOR_SUCCESS = 'DELETE_VENDOR_SUCCESS';
export const DELETE_VENDOR_FAILURE = 'DELETE_VENDOR_FAILURE';

export const GET_VENDORS_REQUEST = 'GET_VENDORS_REQUEST';
export const GET_VENDORS_SUCCESS = 'GET_VENDORS_SUCCESS';
export const GET_VENDORS_FAILURE = 'GET_VENDORS_FAILURE';

export const POST_VENDOR_REQUEST = 'POST_VENDOR_REQUEST';
export const POST_VENDOR_SUCCESS = 'POST_VENDOR_SUCCESS';
export const POST_VENDOR_FAILURE = 'POST_VENDOR_FAILURE';

export const PUT_VENDOR_REQUEST = 'PUT_VENDOR_REQUEST';
export const PUT_VENDOR_SUCCESS = 'PUT_VENDOR_SUCCESS';
export const PUT_VENDOR_FAILURE = 'PUT_VENDOR_FAILURE';

export const DELETE_VENDOR_CONTACT_REQUEST = 'DELETE_VENDOR_CONTACT_REQUEST';
export const DELETE_VENDOR_CONTACT_SUCCESS = 'DELETE_VENDOR_CONTACT_SUCCESS';
export const DELETE_VENDOR_CONTACT_FAILURE = 'DELETE_VENDOR_CONTACT_FAILURE';

export const GET_VENDORS_CONTACTS_REQUEST = 'GET_VENDORS_CONTACTS_REQUEST';
export const GET_VENDORS_CONTATCS_SUCCESS = 'GET_VENDORS_CONTATCS_SUCCESS';
export const GET_VENDORS_CONTACTS_FAILURE = 'GET_VENDORS_CONTACTS_FAILURE';

export const POST_VENDOR_CONTACT_REQUEST = 'POST_VENDOR_CONTACT_REQUEST';
export const POST_VENDOR_CONTACT_SUCCESS = 'POST_VENDOR_CONTACT_SUCCESS';
export const POST_VENDOR_CONTACT_FAILURE = 'POST_VENDOR_CONTACT_FAILURE';

export const PUT_VENDOR_CONTACT_REQUEST = 'PUT_VENDOR_CONTACT_REQUEST';
export const PUT_VENDOR_CONTACT_SUCCESS = 'PUT_VENDOR_CONTACT_SUCCESS';
export const PUT_VENDOR_CONTACT_FAILURE = 'PUT_VENDOR_CONTACT_FAILURE';

export const DELETE_AGENT_REQUEST = 'DELETE_AGENT_REQUEST';
export const DELETE_AGENT_SUCCESS = 'DELETE_AGENT_SUCCESS';
export const DELETE_AGENT_FAILURE = 'DELETE_AGENT_FAILURE';

export const GET_AGENTS_REQUEST = 'GET_AGENTS_REQUEST';
export const GET_AGENTS_SUCCESS = 'GET_AGENTS_SUCCESS';
export const GET_AGENTS_FAILURE = 'GET_AGENTS_FAILURE';

export const POST_AGENT_REQUEST = 'POST_AGENT_REQUEST';
export const POST_AGENT_SUCCESS = 'POST_AGENT_SUCCESS';
export const POST_AGENT_FAILURE = 'POST_AGENT_FAILURE';

export const PUT_AGENT_REQUEST = 'PUT_AGENT_REQUEST';
export const PUT_AGENT_SUCCESS = 'PUT_AGENT_SUCCESS';
export const PUT_AGENT_FAILURE = 'PUT_AGENT_FAILURE';

